export const USER_PERMISSION_KEYS = {
  CUSTOMER_EDIT: 'customer:edit',
  CUSTOMER_EDIT_B2C: 'customer:edit_b2c',
  ORDER_CREATE: 'order:create',
  ORDER_CREATE_B2C: 'order:create_b2c'
};
